<template>
  <div>
    <VisualHero
      image="/assets/img/visual/ucrs-visual-scopri-app-plus.png"
      background-color="bg-black-light"
    >
      <template slot="title">Scopri APP PLUS</template>
    </VisualHero>
    <BreadcrumbsWithShareAccordion :breadcrumbs="breadcrumbs" />
    <section class="py-8 md:py-20 container">
      <UcrsAnchor
        class="mb-10"
        to="/assets/pdf/USC121-InformativaAPPUniCreditRes-ed05_2022_v2_def.pdf"
        target="_blank"
        label="Privacy Informativa relativa all'APP PLUS di UniCredit RE Services"
        icon="download"
        icon-position="left"
        icon-size="md"
      />
      <h2 class="lg:block font-light text-2xl md:text-4xl mb-8 md:mb-20">
        Il mandato a vendere digitale
      </h2>
      <div class="flex flex-col md:flex-row justify-between gap-12">
        <div class="flex-1">
          <p class="mb-8">
            In UniCredit RE Services crediamo nella tecnologia che semplifica la
            vita per risparmiare tempo e aumentare la sicurezza. La novità si
            chiama APP PLUS, una app, in dotazione esclusiva ai consulenti
            immobiliari UniCredit RE Services, che permette ai nostri clienti di
            sottoscrivere il mandato a vendere in maniera totalmente digitale,
            ricevendo tutti i documenti via mail.
          </p>
          <ul class="list-decimal list-inside mb-12">
            <li class="mb-4">
              <strong>SENZA CARTA:</strong><br aria-hidden="true" />tutti i dati
              dei clienti e degli immobili vengono inseriti direttamente
              nell'app attraverso una interfaccia semplice e intuitiva ed una
              esperienza guidata che impedisce gli errori, facilita la
              compilazione e rende immediatamente disponibili le informazioni.
            </li>
            <li class="mb-4">
              <strong>VELOCE:</strong><br aria-hidden="true" />la compilazione a
              schermo permette l'automazione di alcuni processi, consentendo
              maggiore rapidità ed efficienza ed evitando doppi inserimenti per
              le medesime informazioni. Il cliente riceverà tutta la
              documentazione via mail.
            </li>
            <li class="mb-4">
              <strong>ACCESSIBILE OVUNQUE QUANDO VUOI DOVE VUOI:</strong
              ><br aria-hidden="true" />il mandato a vendere può essere firmato
              direttamente sul tablet grazie all'apposito pennino o anche
              semplicemente con il dito.
            </li>
            <li>
              <strong>SICURO:</strong><br aria-hidden="true" />la app è conforme
              ai più alti standard di sicurezza per proteggere e conservare le
              informazioni. Il venditore, una volta che lo avrà ricevuto via
              mail potrà archiviarlo come meglio preferisce o richiederne una
              copia al nostro consulente, con la certezza di non perderlo mai.
            </li>
          </ul>
          <div class="block md:hidden md:max-w-144 mt-8">
            <div class="flex flex-col text-center py-8 bg-white items-center">
              <p class="mb-6 text-2xl">
                {{
                  $store.state.auth.loggedIn
                    ? "Vuoi vendere casa? Gratis per te l'Attestato di Prestazione Energetica (APE)."
                    : "Stai cercando casa e devi anche vendere? Registrati all'area riservata, scopri i nuovi servizi dedicati."
                }}
              </p>
              <a
                class="ucrs-button ucrs-button--primary md:max-w-56"
                :href="
                  $store.state.auth.loggedIn
                    ? '/vendo'
                    : '/area-riservata/registrati'
                "
                >{{
                  $store.state.auth.loggedIn
                    ? 'Scopri di più'
                    : 'Registrati subito'
                }}
              </a>
            </div>
          </div>
          <!-- <div class="mt-20">
            <p class="mb-8 text-xl">Guarda il video:</p>
            <UcrsVideo
              source="/assets/video/ucrs-app-plus.mp4"
              :poster="$img('/assets/img/ucrs-poster-video-app-plus.jpg')"
              controls
              preload="none"
              playsinline
            />
          </div> -->
        </div>
        <div class="hidden md:block md:max-w-144">
          <div class="flex flex-col text-center py-8 bg-white items-center">
            <p class="mb-6 text-2xl">
              Stai cercando casa e devi anche vendere? Registrati all'area
              riservata, scopri i nuovi servizi dedicati.
            </p>
            <a
              class="ucrs-button ucrs-button--primary md:max-w-56"
              href="/area-riservata/registrati"
              >Registrati subito
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Components
import BreadcrumbsWithShareAccordion from '~/components/BreadcrumbsWithShareAccordion.vue'
import UcrsAnchor from '~/components/UcrsAnchor.vue'
// import UcrsVideo from '~/components/UcrsVideo.vue'
import VisualHero from '~/components/VisualHero.vue'

export default {
  components: {
    BreadcrumbsWithShareAccordion,
    UcrsAnchor,
    // UcrsVideo,
    VisualHero,
  },
  async asyncData({ route, $axios }) {
    let meta
    await $axios
      .get('/_api/api/v1/meta', {
        params: {
          slug: route.path,
        },
      })
      .then((res) => {
        meta = res.data.data
      })
      .catch(() => {
        meta = {
          title:
            'Scopri APP PLUS di UniCredit RE Services: Il mandato a vendere digitale',
          description:
            'Cos&#039;è e come funziona APP PLUS, in dotazione esclusiva ai consulenti immobiliari UniCredit RE Services per sottoscrivere il mandato a vendere in maniera digitale.',
        }
      })
    return { meta }
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$store.state.auth.loggedIn ? 'La mia homepage' : 'Home',
          href: '/',
        },
        {
          text: 'Scopri APP PLUS',
        },
      ],
    }
  },
  head() {
    return {
      title: this.meta.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.meta.description,
        },
      ],
    }
  },
}
</script>
